<template>
    <div name="privacy20240314">
        <strong>[솔닥 개인정보 처리방침]</strong><br/><br/>

솔닥 주식회사(이하 "회사")는 정보주체의 자유와 권리 보호를 위해 「개인정보보호법」 및 관계 법령이 정한 바를 준수하며, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.<br/><br/>

이에 「개인정보보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.<br/><br/>

본 개인정보처리방침은 회사가 제공하는 “홈페이지(<a href="http://www.soldoc.co.kr/">www.soldoc.co.kr</a>, <a href="http://www.dr.soldoc.co.kr/">www.dr.soldoc.co.kr</a>)” 및 솔닥 애플리케이션 (이하 홈페이지 및 애플리케이션을 통칭하여 “서비스”)이용에 적용되며, 이를 개정하는 경우 회사가 제공하는 서비스의 공지사항(또는 개별공지)을 통하여 공지합니다.<br/><br/>

회사의 개인정보처리방침의 목차는 아래와 같습니다.<br/><br/>

1. 개인정보의 처리 목적<br/>
2. 개인정보의 처리 및 보유 기간<br/>
3. 처리하는 개인정보의 항목<br/>
4. 개인정보의 제3자 제공<br/>
5. 개인정보 처리의 위탁<br/>
6. 개인정보의 파기<br/>
7. 개인정보주체와 법정대리인의 권리·의무 및 행사방법<br/>
8. 개인정보의 안전성 확보 조치<br/>
9. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항<br/>
10. 개인정보 보호책임자 및 개인정보 열람청구<br/>
11. 권익침해 구제 방법<br/>
12. 개인정보 처리방침의 변경<br/><br/>

<strong>개인정보의 처리 목적</strong><br/><br/>

회사는 다음의 목적을 위하여 개인정보를 처리합니다.<br/><br/>

처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br/><br/>

1. 회원가입 및 관리<br/>
- 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동 개인정보 수집 시 법정대리인 동의 여부 확인, “솔닥” 이용약관 위반 회원에 대한 이용제한 조치, 가입 및 가입 횟수 제한, 각종 고지·통지, 고충처리, 분쟁 조정을 위한 기록 보존, 민원사무 처리, 서비스 이용에 대한 통계 수집 목적으로 개인정보를 처리합니다.<br/><br/>

2. 서비스 제공에 관한 계약 이행 및 요금 정산<br/>
- 비대면 진료 예약, 예약 조회 및 예약 일정에 대한 고지, 서비스 요금 결제, 의약품 처방, 배송 서비스, 처방전 발행 또는 배달 서비스 제공, 물품 배송 또는 청구서 등 발송, 금융거래 본인 인증 및 결제 서비스 등 계약 체결 및 이행을 위한 목적으로 개인정보를 처리합니다.<br/><br/>

3. 신규 서비스 개발 및 마케팅, 광고 제공<br/>
- 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 정보 및 참여기회 제공, 광고성 정보 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계기타 문의, 서비스 요청에 대한 응대 및 처리<br/>
- 병원 제휴 문의에 대한 처리, 컨텐츠 요청에 대한 응대 및 안내, 병원 상담 요청에 대한 내용 전달<br/><br/>

<strong>개인정보의 처리 및 보유 기간</strong><br/><br/>

① 회사는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.<br/><br/>

② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br/><br/>

1. 서비스 이용자의 개인정보는 원칙적으로 이용자의 이용계약 해지(회원 탈퇴) 시까지 보관 후 폐기하되, 개인정보의 수집 및 이용 목적이 달성되는 경우 지체 없이 파기됩니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간까지 보존합니다.<br/><br/>

2. 회사 내부 방침에 의한 정보 보관 사유<br/>
- 회사는 불량 이용자의 부정한 이용의 재발을 방지하기 위해 이용계약 해지일(회원 탈퇴일)로부터 6개월간 해당 이용자의 개인정보를 보관합니다.<br/>
- 회사는 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 다른 이용자를 보호하고 사법기관 수사의뢰 시 증거자료로 활용하기 위해 이용계약 해지일(회원 탈퇴일)로부터 6개월간 해당 이용자의 개인정보를 보관합니다.<br/><br/>

3. 관련 법령에 의한 정보 보관 사유<br/>

<table border="1">
  <tr>
    <th>근거</th>
    <th>보관 정보</th>
    <th>보존 기간</th>
  </tr>
  <tr>
    <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
    <td>표시·광고에 관한 기록</td>
    <td>6개월</td>
  </tr>
  <tr>
    <td></td>
    <td>계약 또는 청약철회 등에 관한 기록</td>
    <td>5년</td>
  </tr>
  <tr>
    <td></td>
    <td>대금결제 및 재화 등의 공급에 관한 기록</td>
    <td>5년</td>
  </tr>
  <tr>
    <td></td>
    <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
    <td>3년</td>
  </tr>
  <tr>
    <td>의료법</td>
    <td>처방전</td>
    <td>2년</td>
  </tr>
  <tr>
    <td></td>
    <td>진단서 등의 부본</td>
    <td>3년</td>
  </tr>
  <tr>
    <td></td>
    <td>환자 명부, 검사소견기록, 간호기록부,</td>
    <td>5년</td>
  </tr>
  <tr>
    <td></td>
    <td>방사선 사진 및 그 소견서, 조산기록부</td>
    <td>5년</td>
  </tr>
  <tr>
    <td></td>
    <td>진료기록부, 수술기록</td>
    <td>10년</td>
  </tr>
  <tr>
    <td>약사법</td>
    <td>비급여 처방전</td>
    <td>2년</td>
  </tr>
  <tr>
    <td>의료급여법</td>
    <td>의료급여 관련 처방전</td>
    <td>3년</td>
  </tr>
</table>

* 정보주체로부터 별도로 진료 기록, 처방 관련 문서를 제공받은 경우 본 개인정보 처리방침에 따라 6개월 간 보관 후 폐기합니다. 다만, 병원 및 약국과의 개인정보 처리 위수탁 계약에 따라 수탁자로서 진료기록부, 처방전 등을 보관하는 경우 위수탁 계약 기간 동안 보유하고 계약 종료 시 이를 폐기함을 원칙으로 합니다. 다만, 회사가 병원 및 약국의 개인정보처리 수탁자로서 위 각 정보를 보관하는 경우 각 법령에 정한 기간 동안 각 정보를 보관합니다.<br/><br/>

<strong>처리하는 개인정보의 항목</strong><br/><br/>

① 회사는 서비스 운영에 필요한 최소한의 개인정보만 수집하며, 서비스 이용을 위하여 개인정보가 추가로 필요한 경우 회원에게 별도의 동의를 받은 후 개인정보를 수집할 예정입니다.<br/><br/>

<table border="1">
  <tr>
    <th>구분</th>
    <th>처리항목</th>
    <th>세부내용</th>
  </tr>
  <tr>
    <td>회원 가입 및 관리</td>
    <td>일반 회원</td>
    <td>이름, 이메일, 휴대폰 번호, 생년월일, 카카오톡 ID, 회원 탈퇴 사유, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)</td>
  </tr>
  <tr>
    <td></td>
    <td>제휴 의사/약사 회원</td>
    <td>이름, 아이디, 비밀번호, 생년월일, 사진, 이메일, 휴대폰 번호, 면허번호, 근무처 정보(병원/약국명, 주소, 연락처), 결제정보(계좌정보, 진료비용, 조제비), 학력, 경력, 진료과목, 배달가능과목, 전문분야, 요양기관번호, 사업자등록번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)</td>
  </tr>
  <tr>
    <td>진료예약, 비대면 진료 등 서비스 제공</td>
    <td>비대면 진료 예약, 알림</td>
    <td>카카오톡 ID, 휴대폰 번호, 이름, 주소, 생년월일, 이메일, 초·재진여부, 진료시간(비대면 진료 가능한 날짜·시간), 진료과목, 진료신청서, 선호의약품, 화상진료 영상, 처방전 및 처방정보</td>
  </tr>
  <tr>
    <td></td>
    <td>진료를 위한 기본정보</td>
    <td>성별, 신장, 체중, 혈액형, 이메일</td>
  </tr>
  <tr>
    <td></td>
    <td>진료를 위한 생활방식 정보</td>
    <td>흡연, 음주, 활동량</td>
  </tr>
  <tr>
    <td></td>
    <td>진료를 위한 사전 문진 정보</td>
    <td>증상에 대한 설명, 증상 사진</td>
  </tr>
  <tr>
    <td></td>
    <td>결제 카드 등록</td>
    <td>카드사, 카드종류, 카드번호, 카드비밀번호 앞 2자리, 유효기간</td>
  </tr>
  <tr>
    <td></td>
    <td>배송 정보</td>
    <td>수령인 이름, 휴대폰 번호, 배송주소</td>
  </tr>
  <tr>
    <td></td>
    <td>이용 관련 정보</td>
    <td>서비스 이용기록, 접속로그, 접속 IP 정보, 의사 정보, 진료과목, 전문분야, 진료예약 내역</td>
  </tr>
  <tr>
    <td></td>
    <td>서비스 후기 수집</td>
    <td>사용후기</td>
  </tr>
  <tr>
    <td>기타 정보</td>
    <td>서비스 이용 관련 민원상담, 고충처리</td>
    <td>서비스 이용 기록, 접속로그, 접속 IP 정보, 의사 정보, 진료과목, 전문분야, 진료예약 내역, 상담 내역, 이메일, 휴대폰 번호</td>
  </tr>
  <tr>
    <td></td>
    <td>계좌이체 이용 결제, 환불 이용 시</td>
    <td>예금주, 은행명, 계좌번호</td>
  </tr>
  <tr>
    <td></td>
    <td>서비스 개선</td>
    <td>접속 기기 정보, 접속 로그, IP 주소, 쿠키, 기기고유번호, 방문일시, 불량 이용 기록, 사용 이동통신사, 광고식별자</td>
  </tr>
</table>

② 회사는 「개인정보보호법」과 「정보통신망법」상 개인정보 처리방침 및 개인정보보호위원회가 정한 「표준 개인정보 보호지침」을 준수하고 있습니다. 회사는 개인정보처리방침을 통하여 귀하가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려 드립니다.<br/><br/>

③ 회사는 개인정보 처리방침을 사이트 첫 화면과 고객센터의 ‘개인정보 처리방침’ 항목에서 공개함으로써 이용자들이 언제나 용이하게 볼 수 있도록 조치하고 있습니다.<br/><br/>

④ 회사는 개인정보 처리방침의 지속적인 개선을 위하여 개인정보 처리방침을 개정하는데 필요한 절차를 정하고 있습니다. 그리고 개인정보 처리방침을 개정하는 경우 버전번호 등을 부여하여 개정된 사항을 이용자가 쉽게 알아볼 수 있도록 하고 있습니다.<br/><br/>

⑤ 서비스 아이디를 이용한 부가 서비스 및 맞춤식 서비스 이용 또는 이벤트 응모 과정에서 해당 서비스의 이용자에 한하여, 추가적으로 개인정보 처리가 발생할 수 있습니다. 해당 개인정보 처리 시점에서 이용자에게 처리하는 개인정보 항목(이름, 휴대폰 번호, 이벤트 응모 및 상담 내용), 처리목적, 개인정보 보유 및 이용기간에 대해 안내 드리고 동의를 받습니다.<br/><br/>

⑥ 회사는 파트너스 가입, 디지털 왕진 가입을 통해 제휴된 의료기관, 약국, 요양원, 복지시설과 개인정보처리업무에 관한 위수탁 계약을 체결하였으며, 비대면 진료 제공, 처방전 발행, 진료기록 작성 및 열람, 의약품 조제 업무를 위해 회원의 주민등록번호(또는 외국인등록번호)를 처리하고 있습니다. 수집된 주민등록번호는 해당 목적만을 위해 사용되며 암호화 조치를 통해 안전하게 관리되고 있습니다.<br/><br/>

<strong>개인정보의 제3자 제공</strong><br/><br/>

① 회사는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보보호법」 제17조, 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.<br/><br/>

② 회사는 원활한 서비스 제공을 위해 다음의 경우 정보주체의 동의를 얻어 필요 최소한의 범위로만 개인정보를 제공합니다.<br/><br/>

<table border="1">
  <tr>
    <th>제공받는 자</th>
    <th>제공 목적</th>
    <th>제공 내용</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td>솔닥 제휴 의료진</td>
    <td>진료 서비스 제공(진료예약, 취소, 진료내역 확인 및 관리, 처방 문의 및 상담), 마케팅[*1].</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호, 환자 문진 정보, 증상 정보, 증상 관련된 첨부 사진 정보, 환자의 과거 진료내역, 진료 영상 기록</td>
    <td rowspan="3">개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지[*1]. 단, 관련 법령에 따라 별도 보관되는 정보의 경우 해당 법령에 정한 기간까지</td>
  </tr>
  <tr>
    <td>솔닥 제휴 약국</td>
    <td>약 배송 서비스 제공(처방전 확인 및 조제, 배송, 대리수령, 복약지도, 문의 및 상담)</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호, 처방전, 배송 주소, 보호자 이름, 복지시설 직원 이름, 환자와의 관계 정보</td>
    <td></td>
  </tr>
  <tr>
    <td>솔닥 제휴 기관(노인·장애인복지시설)</td>
    <td>비대면 진료 서비스 이용 보조, 약 배송 서비스 보조, 복약지도</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호, 증상 정보, 의사 이름, 약사 이름, 처방전 중 복약지도 관련 항목</td>
    <td></td>
  </tr>
</table>

[*1] 마케팅에 관한 사항은 선택사항으로 별도 동의를 받습니다.<br/>
[*2] 동의 거부에 따른 불이익: “솔닥” 비대면 진료 서비스 이용 제한<br/><br/>

③ 회사는 예외적으로 아래의 경우 이용자의 개인정보를 제3자에게 제공, 공유할 수 있습니다.<br/>
- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우<br/>
- 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우<br/>
- 회사의 정당한 이익을 달성하기 위하여 필요한 경우로서 명백하게 이용자의 권리보다 우선하는 경우. 이 경우 회사의 정당한 이익과 상당한 관련이 있고 합리적인 범위를 초과하지 않는 경우에 한함.<br/>
- 공중위생 등 공공의 안전과 안녕을 위하여 긴급히 필요한 경우<br/><br/>

<strong>개인정보 처리의 위탁</strong><br/><br/>

① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br/><br/>

<table border="1">
  <tr>
    <th>위탁받는 자(수탁자)</th>
    <th>위탁하는 업무</th>
    <th>보유 및 이용기간</th>
  </tr>
  <tr>
    <td>엔에이치엔고도㈜</td>
    <td>주문을 위한 주문자, 주문정보 등 주문 및 취소에 따른 관련 정보</td>
    <td>회원탈퇴 후 6개월까지</td>
  </tr>
  <tr>
    <td>NHN한국사이버결제 주식회사</td>
    <td>주문을 위한 주문자 주문정보 등 주문 및 취소에 따른 관련 정보</td>
    <td>회원탈퇴 후 6개월까지</td>
  </tr>
  <tr>
    <td>케이지이니시스</td>
    <td>주문을 위한 주문자 주문정보 등 주문 및 취소에 따른 관련 정보</td>
    <td>회원탈퇴 후 6개월까지</td>
  </tr>
  <tr>
    <td>Amazon Web Services, Inc.</td>
    <td>서비스 제공 및 분석을 위한 인프라 관리</td>
    <td>회원탈퇴 후 6개월까지</td>
  </tr>
  <tr>
    <td>㈜카카오</td>
    <td>카카오톡 채널을 이용한 메세지 발송, 서비스 제공 및 분석을 위한 인프라 관리</td>
    <td>회원탈퇴 후 6개월까지</td>
  </tr>
</table>

② 회사는 위탁계약 체결 시 「개인정보보호법」 제26조, 같은 법 시행령 제28조에 따라 위탁업무 수행 목적 외 개인정보 처리 금지, 개인정보의 기술적·관리적 보호조치, 위탁업무의 목적 및 범위, 재위탁 제한, 개인정보에 대한 접근 제한 등 안정성 확보 조치, 위탁업무와 관련하여 보유하고 있는 개인정보의 관리 현황 점검 등 감독, 수탁자가 준수하여야 할 의무를 위반한 경우의 손해배상 책임에 관한 사항을 계약서 등 문서(전자문서)에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.<br/><br/>

③ 위탁업무의 내용이나 수탁자가 변경될 경우, 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.<br/><br/>

<strong>개인정보의 파기</strong><br/><br/>

① 회사는 개인정보 보유기간이 경과된 경우, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.<br/><br/>

② 회사는 정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 다른 개인정보와 별도의 데이터베이스(DB)로 옮겨 분리하여 저장, 관리합니다. 회사는 별도 DB로 옮긴 개인정보를 법률에 의한 경우가 아니고서는 보유하는 외 다른 목적으로 이용하지 않습니다.<br/><br/>

③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.<br/><br/>

1. 파기절차<br/>
- 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 책임 하 개인정보를 파기합니다.<br/><br/>

2. 파기방법<br/>
- 회사는 전자적 파일 형태로 기록·저장된 개인정보는 복원이 불가능한 방법 내지 기록을 재생할 수 없는 기술적 방법으로 영구히 삭제합니다. 종이나 그 밖의 기록 매체에 저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.<br/><br/>

<strong>개인정보주체와 법정대리인의 권리·의무 및 행사방법</strong><br/><br/>

① 정보주체는 회사에 대해 언제든지 “솔닥” 서비스를 통하여 등록된 개인정보의 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다. [*] 만 14세 미만 아동에 관한 개인정보의 열람 등의 요구는 법정대리인이 직접 해야 하며, 만 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도 있습니다.<br/><br/>

② 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 ‘개인정보변경’(또는 ‘이용자정보수정’ 등)을, 가입해지(동의철회)를 위해서는 “이용자탈퇴”를 클릭하여 본인 확인 절차를 거친 후 직접 열람, 정정 또는 탈퇴가 가능합니다.<br/><br/>

③ 권리 행사는 개인정보 보호책임자 및 담당자에 대하여 서면, 전화, 이메일 등을 통하여 하실 수 있으며, 이 경우 회사는 지체 없이 그 개인정보를 조사하여 이용자의 요구에 따라 지체없이 필요한 조치를 한 후 그 결과를 이용자에게 알리겠습니다.<br/><br/>

④ 개인정보 열람 및 처리정지 요구의 경우, 「개인정보보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.<br/><br/>

⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.<br/><br/>

⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리 정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.<br/><br/>

⑦ “모바일 접수/예약 서비스”의 경우, 회원(병/의원) 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “모바일 접수/예약 서비스”가 수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리합니다. “모바일 접수/예약 서비스”의 회원탈퇴는 “솔닥”의 다른 서비스의 탈퇴와 무관합니다.<br/><br/>

<strong>개인정보의 안전성 확보 조치</strong><br/><br/>

① 회사는 개인정보의 안전성 확보를 위하여 아래 각 호의 조치를 포함하여 개인정보 보호법 제29조, 같은 법 시행령 제30조, 개인정보의 안전성 확보조치 기준(개인정보보호위원회 고시)에 따른 조치를 취하고 있습니다.<br/><br/>

1. 기술적 조치<br/>
- 이용자의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.<br/>
- 회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.<br/>
- 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점 분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.<br/><br/>

2. 관리적 조치<br/>
- 회사는 이용자의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있으며 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자, 개인정보 보호책임자 및 담당자 등 개인정보관리업무를 수행하는 자, 기타 업무상 개인정보의 취급이 불가피한 자 외에는 접근을 엄격히 제한하고 담당직원에 대한 수시 교육을 통하여 본 정책의 준수를 강조하고 있습니다.<br/><br/>

3. 물리적 조치<br/>
- 전산실, 자료보관실 등의 접근 통제<br/><br/>

② 회사는 이용자 본인의 부주의나 기본적인 네트워크 상의 위험성으로 인해 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 일체의 책임을 지지 않습니다. 이용자 개개인이 본인의 개인정보 보호를 위하여 ID와 비밀번호를 적절하게 관리하고, 제3자에게 노출되지 않도록 주의하셔야 합니다.<br/><br/>

<strong>개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</strong><br/><br/>

① 회사는 이용자에게 특화된 맞춤서비스를 제공하기 위해서 이용 정보를 저장하고 수시로 불러오는 ’쿠키(cookie)’를 사용합니다.<br/><br/>

② 쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.<br/><br/>

1. 쿠키의 사용 목적<br/>
- 이용자들이 방문한 “솔닥”의 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 이용자 규모 등을 파악하여 이용자에게 최적화된 정보 제공을 위하여 사용합니다.<br/><br/>

2. 쿠키의 설치/운영 및 거부<br/>
- 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.<br/>
- 쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.<br/>
- 설정방법 예(구글 크롬의 경우): 웹 브라우저 상단의 ‘︙’ > 설정 > 개인정보 및 보안 > 쿠키 및 기타 사이트 데이터 > 쿠키 차단<br/><br/>
- 다만, 쿠키의 저장을 거부할 경우에는 맞춤형 서비스 이용에 어려움이 있을 수 있습니다.<br/><br/>

<strong>개인정보 보호책임자 및 개인정보 열람청구</strong><br/><br/>

① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br/><br/>

② 정보주체는 「개인정보보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.<br/><br/>

③ 정보주체는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다.<br/><br/>

<table border="1">
  <tr>
    <th>개인정보 보호책임자</th>
    <th>개인정보보호 담당자</th>
    <th>연락처</th>
  </tr>
  <tr>
    <td>김민승</td>
    <td>이승도</td>
    <td>전화번호: 02-6954-7676 이메일: <a href="mailto:info@soldoc.co.kr">info@soldoc.co.kr</a></td>
  </tr>
</table>

<strong>개인위치정보의 처리</strong><br/><br/>

회사는 「위치정보의 보호 및 이용 등에 관한 법률」에 따라 이용자의 개인위치정보를 안전하게 관리합니다.<br/><br/>

① 개인위치정보의 처리목적 및 보유기간<br/><br/>

<table border="1">
  <tr>
    <th>서비스명</th>
    <th>서비스 내용 및 목적</th>
    <th>개인위치정보 보유기간</th>
  </tr>
  <tr>
    <td>약국찾기</td>
    <td>사용자에게 처방약 수령을 위한 근거리의 약국 정보 제공</td>
    <td>기록 시점으로부터 6개월</td>
  </tr>
</table>

② 개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간<br/><br/>

- 회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 따라 위치정보 이용·제공사실 확인자료를 자동 기록·보존하며 해당 자료는 기록 시점으로부터 6개월간 보관합니다.<br/><br/>

③ 개인위치정보의 파기 절차 및 방법<br/><br/>

- 회사는 개인위치정보의 이용 또는 제공목적을 달성한 때에는 위치정보 이용·제공사실 확인자료를 제외한 개인위치정보를 즉시 파기합니다.<br/><br/>

다만, 다른 법률에 따라 보유하여야 하거나 이용자가 개인위치정보의 보유에 별도로 동의한 경우에는 이용자가 동의한 때로부터 최대 1년간 이를 보유할 수 있습니다.<br/><br/>

④ 개인위치정보의 제3자 제공 및 통보<br/><br/>

- 회사는 이용자의 사전 동의 없이 개인위치정보를 제3자에게 제공하지 않으며, 이용자가 지정한 제3자에게 개인위치정보를 제공하는 경우 매회 이용자에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.<br/>
- 위에 불구하고 이용자는 「위치정보의 보호 및 이용 등에 관한 법률 시행령」 제24조에 따라 정보제공내역을 30일마다 모아서 통보받는 방법을 선택할 수 있으며, 이용자가 회사의 절차에 따라 요청할 경우 위에 따른 즉시 통보 방법으로 변경할 수 있습니다.<br/><br/>

⑤ 8세 이하의 아동 등의 보호의무자의 권리·의무와 그 행사방법<br/><br/>

- 회사는 8세 이하의 아동, 피성년후견인, 「장애인복지법」 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진 자로서 「장애인고용촉진 및 직업재활법」 제2조 제2호의 규정에 의한 중증장애인에 해당하는 자(「장애인복지법」 제32조의 규정에 의하여 장애인등록을 한 자에 한함)(이하 “8세 이하의 아동 등”)의 보호의무자의 권리·의무 및 행사방법에 관련하여서, 「솔닥 위치기반서비스 이용약관」 제11조에 따라 처리합니다.<br/><br/>

⑥ 회사의 위치정보관리책임자는 위 개인정보 보호책임자가 겸직하고 있습니다.<br/><br/>

<strong>권익침해 구제 방법</strong><br/><br/>

① 회사는 개인정보보호와 관련하여 이용자들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. 이용자들은 위 “개인정보 보호책임자 및 개인정보 열람청구” 항을 참고하여 전화나 메일을 통하여 불만사항을 신고할 수 있고, 회사는 이용자들의 신고사항에 대하여 신속하게 처리하여 답변해 드립니다.<br/><br/>

② 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국 인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.<br/><br/>

- 개인정보분쟁조정위원회: 1833-6972 (<a href="https://www.kopico.go.kr/">www.kopico.go.kr</a>)<br/>
- 개인정보침해신고센터: 118 (<a href="https://privacy.kisa.or.kr/">privacy.kisa.or.kr</a>)<br/>
- 대검찰청: 1301 (<a href="https://www.spo.go.kr/">www.spo.go.kr</a>)<br/>
- 경찰청: 182 (<a href="https://ecrm.police.go.kr/">ecrm.police.go.kr</a>)<br/><br/>

③ 「개인정보보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.<br/><br/>

- 중앙행정심판위원회: 110 (<a href="https://www.simpan.go.kr/">www.simpan.go.kr</a>)<br/><br/>

<strong>개인정보 처리방침의 변경</strong><br/><br/>

회사는 개인정보 처리방침을 변경하는 경우에 개인정보주체인 이용자가 그 변경 여부, 변경된 사항의 시행시기와 변경된 내용을 언제든지 쉽게 알 수 있도록 지속적으로 서비스를 통하여 공개합니다. 이 경우에 변경된 내용은 변경 전과 후를 비교하여 공개합니다.<br/><br/>

공고일자: 2024년 3월 14일<br/><br/>
시행일자: 2024년 3월 21일<br/><br/>

    </div>
</template>

<script>
export default {
    name: 'privacy20240314'
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/barocare/contents/privacy/20240314.vue